import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// 

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HotToastService } from '@ngneat/hot-toast';

// Jquery?
import * as $ from "jquery"
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AllRecipients } from 'src/app/shared/models/allRecipients.model';
// import { TestingCompiler } from '@angular/core/testing/src/test_compiler';

@Component({
  selector: 'app-subject-com-type-view',
  templateUrl: './subject-com-type-view.component.html',
  styleUrls: ['./subject-com-type-view.component.css']
})
export class SubjectComTypeViewComponent implements OnInit {
  subject_com_types: any;
  subject_com_type_id: any;
  subject_template_docs: Object;

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size?; // side | abstract | full
  @Input() current_field_name?;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('closeParentModelDefault') closeParentModelDefault: EventEmitter<any> = new EventEmitter();

   // Function below pushes form to allRecipients array, and closes window.
   @Output('addRecipientFromModal') addRecipientFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationFromModal') addAutomationFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationFromModal_2') addAutomationFromModal_2: EventEmitter<any> = new EventEmitter();
   
   @Output('addAutomationCommunicationFromModal') addAutomationCommunicationFromModal: EventEmitter<any> = new EventEmitter();
   @Output('addAutomationCommunicationFromModal_2') addAutomationCommunicationFromModal_2: EventEmitter<any> = new EventEmitter();
   

   model: AllRecipients;


  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  initialPage: { pageSize: number; };


  constructor(
    private http: HttpClient, private router: Router, private _demoService: DemoService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    public toastr: HotToastService,
    public gfunc: GlobalFunctionsService
  ) {
    this.subject_com_type_id = +this.route.snapshot.paramMap.get('subject_com_type_id');
   }

  ngOnInit() {

    this.getSubjectComType(this.subject_com_type_id);
    this.getSubjectTemplateDocsGrid(this.subject_com_type_id);

    // Load all the documents for the picker.
    // || this.widget_size == 'picker-communication_2'
    if (this.widget_size == 'picker' || this.widget_size == 'picker_2' || this.widget_size == 'picker-communication' ){
      this.getSubjectTemplateDocsGridSearch(this.subject_com_type_id);
    }

    if ( this.widget_size == 'picker-communication_2'){
      this.getSubjectTemplateDocsGridSearch2Passed(this.subject_com_type_id);
    }


    // syncfusion GRID OPTIONS
    this.toolbarOptions = ['Search'];
    this.initialPage = { pageSize: 5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions = {type: 'date', format: 'dd/MM/yyyy'};
  // end grid options

  }


  private getSubjectComType(subject_com_type_id) {
    this._demoService.getSubjectComType(subject_com_type_id)
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }


  private getSubjectTemplateDocsGrid(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocsGrid(subject_com_type_id)
      .subscribe(
        res => this.subject_template_docs = res,
        err => console.error(err.status)
      );
  }


  private getSubjectTemplateDocsGridSearch(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocsGridSearch(subject_com_type_id)
      .subscribe(
        res => this.subject_template_docs = res,
        err => console.error(err.status)
      );
  }

  private getSubjectTemplateDocsGridSearch2Passed(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocsGridSearch2Passed(subject_com_type_id)
      .subscribe(
        res => this.subject_template_docs = res,
        err => console.error(err.status)
      );
  }


 // Grid Functions
 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

refreshGrid(){ // refresh the databutton
  this.getSubjectTemplateDocsGrid(this.subject_com_type_id);
  this.grid.refresh();
};


gridItemView(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_view/' + id + '']);
}

gridItemEdit(id) {
  this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + id + '']);
}



deleteSubjectTemplateDoc(doc_id) {
  if (confirm('Are you sure you want to delete this communication template. It cannot be undone!? ')) {
  this._demoService.deleteSubjectTemplateDoc(doc_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    this.toastr.success('Subject Communication template Removed. We have left all docx and themes original files on the server');
    //  this.getSubjectAgentAssigned(subject_id);
    this.gfunc.globalSystemSubjectTemplateDocsSkipRoute(this.subject_com_type_id);
      //  return true;
     },
     error => {
       console.error('Error removing communication template!');
       return error(error.error);
     }
  );
  
  }
  

// end grid functions

} // end if

}
